<label
  class="gw-flex gw-items-end gw-gap-2 gw-cursor-pointer gw-w-full"
  [class.gw-opacity-70]="readonly"
  [class.gw-cursor-not-allowed]="readonly"
>
  <input
    tuiRadio
    type="radio"
    [formControl]="control"
    [name]="name"
    [value]="value"
    [id]="name + '-' + value"
    class="gw-w-x-large gw-h-x-large gw-flex-shrink-0 gw-accent-background-accent-1"
    [class.gw-mt-small]="!!label"
    [disabled]="readonly"
  />

  <div class="gw-flex gw-flex-col gw-gap-1 gw-flex-1" *ngIf="label">
    <span tuiTitle class="gw-text-text-primary gw-text-medium">{{
      label
    }}</span>
    <span tuiSubtitle *ngIf="caption" class="gw-text-text-secondary gw-text-xs">
      {{ caption }}
    </span>
  </div>
</label>
